<template>
    <tmo-group-footer-replica :footer-menu="footerMenu"></tmo-group-footer-replica>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import TmoGroupFooterReplica from '@/header-footer-replicas/common/footers/tmo-group-footer-replica.vue';

export default defineComponent({
    name: 'TmoSgFooterReplica',
    components: { TmoGroupFooterReplica },
    data() {
        return {
            footerMenu: {
                imageUrl: 'https://images.squarespace-cdn.com/content/v1/62687d32611a1c7ec290db63/e3173558-1ac8-4d66-89bc-7a6b05f7fda8/SGTMO%2Bwords%2Band%2Bflag%2Bon%2Bwhite.jpg',
                countryName: 'Singapore',
                tmoCountries: [    
                    {
                        name: 'Singapore',
                        url: 'https://www.trademarksonline.com.sg/'
                    },               
                    {
                        name: 'Malaysia',
                        url: 'https://www.trademarksmalaysia.my/'
                    },                    
                    {
                        name: 'New Zealand',
                        url: 'https://www.diytm.co.nz/'
                    },
                    {
                        name: 'Australia',
                        url: 'https://www.trademarksonline.com.au/'
                    },
                    {
                        name: 'United Kingdom',
                        url: 'https://www.trademarksonline.co.uk/'
                    },
                ],
                contactUrl: 'https://www.trademarksonline.com.sg/contact',
                termsUrl: 'https://www.trademarksonline.com.sg/terms-of-use',
                privacyUrl: 'https://www.trademarksonline.com.sg/privacy-policy',
            }
        }
    }
});

</script>
